import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'components/common';
import MainFieldSet from './MainFieldSet';


const NotificationTemplateForm = (props) => {
  const { showEditForm } = props.notificationTemplate;

  const onClose = () => {
    props.actions.notificationTemplate.showEditForm({ show: false });
  };

  const onSubmit = (data) => {
    const newData = Object.assign(data, {
      site: props.site.activeId,
    });
    props.actions.notificationTemplate.update(newData);
  };

  return (
    <Form
      width={800}
      title="Редактирование шаблона уведомления"
      model={props.notificationTemplate}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={{ sort: 100 }}
      convertEditObject={(editObject) => ({
        ...editObject,
      })}
    >
      <MainFieldSet {...props} />
    </Form>
  );
};

const mapState = (state) => ({
  site: state.site,
  auth_token: state.auth.token,
  notificationTemplate: state.notificationTemplate,
});

const mapDispatch = (dispatch) => ({
  actions: {
    notificationTemplate: dispatch.notificationTemplate,
  },
});

export default connect(mapState, mapDispatch)(NotificationTemplateForm);
